export function displayName(fname: string, lname: string) {
  return `${fname} ${lname}`.trim();
}
